export * from "-!../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./topbar-buttons-block.vue?vue&type=template&id=4610b3a4"


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/common/topbar/topbar-buttons-block.vue?vue&type=template&id=4610b3a4
// module id = JwzS
// module chunks = 0